// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dsn-dark-mode employee-cost-component .result,.dsn-dark-mode employee-cost-component .dollar-symbol,.dsn-dark-mode employee-cost-component .label-input{color:#a5a6a7 !important}`, "",{"version":3,"sources":["webpack://./src/shared/components/employee-cost/themes/employee-cost.component-dark.scss"],"names":[],"mappings":"AAIQ,yJAGI,wBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
